import React from 'react';
import { UCAModule, CommonModule } from "uca-react-containers-library";
import Loader from './loader';

const DiscountProgramsWebViewComponent = () => {
    const { isLoading } = CommonModule.useWebView();
    const { saveRouteData } = CommonModule.useRoute();

    React.useEffect(() => {
        saveRouteData({ 'currentPage': 'Student Discount' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) return <Loader></Loader>;

    return (
        <CommonModule.ViewportProvider>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 my-3">
                <UCAModule.DiscountProgramsWebView />
            </div>
        </CommonModule.ViewportProvider>
    );
};

export default DiscountProgramsWebViewComponent;